export class FormInvoice {
    constructor() {
        this.data = {};

        if (this.isPaymentInvoice()){
            let formData = new FormData(document.getElementById('formInvoice'));
            for(let data of formData.entries()) {
                this.data[data[0]] = data[1];
            }
        }
    }

    isPaymentInvoice(){
        if (document.querySelector('#paymentInvoice')){
            return document.querySelector('#paymentInvoice').checked;
        }
        return false;
    }
}